import NoPosts from './NoPosts';

export default NoPosts;
